<div class="authorize-payment-form">
  <div class="wrap wrapClose">
    <div class="wrapClose__content header">
      <div class="header__content">
        <div class="header__logo-image--blue wrapClose__logo" alt="Coverpath"></div>
        <button type="button" class="close" (click)="closeModal()">Close</button>
      </div>
    </div>
  </div>

  <div class="wrap wrapHead authorize-payment-form__heading-container">
    <div class="pageHead">
      <h1 class="authorize-payment-form__sub-heading">Make a payment</h1>
      <h2 class="authorize-payment-form__sub-heading__first-line" *ngIf="!hasPaymentFailed && !paymentDatePast">
        Your next premium is due soon.
      </h2>
      <h2 *ngIf="hasPaymentFailed" class="authorize-payment-form__sub-heading__first-line">
        Your premium payment failed on {{ paymentFailureDate }}.
      </h2>
      <h2 class="authorize-payment-form__sub-heading">
        Authorize a payment to be drafted from your bank account on the payment date shown below.
      </h2>
    </div>
  </div>
  <div class="authorize-payment-form-table wrap wrapHead">
    <div class="authorize-payment-form-table__head">
      <h3 class="authorize-payment-form-table__title">Payment Details</h3>
    </div>
    <div class="authorize-payment-form-table__row">
      <div class="authorize-payment-form-table__cell authorize-payment-form-table__cell--heading">
        <span class="authorize-payment-form-table__data-text">Amount</span>
      </div>
      <div class="authorize-payment-form-table__cell authorize-payment-form-table__cell--data">
        <span class="authorize-payment-form-table__data-text"> {{ totalPremium }} </span>
      </div>
    </div>
    <div class="authorize-payment-form-table__row" *ngIf="!paymentDatePast">
      <div class="authorize-payment-form-table__cell authorize-payment-form-table__cell--heading">
        <span class="authorize-payment-form-table__data-text">Payment Date</span>
      </div>
      <div class="authorize-payment-form-table__cell authorize-payment-form-table__cell--data">
        <span class="authorize-payment-form-table__data-text"> {{ nextPaymentDate }} </span>
      </div>
    </div>
  </div>
  <div class="authorize-payment-form-table wrap wrapMain">
    <authorize-payment-bank-account-form
      (updateComplete)="updateComplete()"
      (closeModal)="closeModal()"
      [payerName]="payerName"
      [policyNumber]="policyNumber"
      [useSecondary]="useSecondary"
      [effectiveDraftDate]="effectiveDraftDate"
      [totalPremium]="totalPremium"
      [accountType]="accountType"
      [bankAccountLastFour]="bankAccountLastFour"
      [invoiceId]="invoiceId"
      [hasPaymentFailed]="hasPaymentFailed"
      [isAnnualPayment]="isAnnualPayment"
      [isAutoPay]="isAutoPay"
      [isBillingPaused]="isBillingPaused"
    >
    </authorize-payment-bank-account-form>
  </div>
</div>
